import { FC, ReactNode, useState } from 'react'
import { UpgradePlanModal } from 'src/components/UpgradePlanModal'
import { EmptyState } from 'src/pages/AIListening/EmptyState'
import { useGetUserFeaturesQuery } from 'src/reactQuery/useGetUserFeaturesQuery'

interface AiListeningRouteProps {
  children: ReactNode
}

// The gate for the whole AI Listening module, rather than its landing page
// alone: campaign creation and the two detail pages have addresses of their
// own, and a bookmark or a link in a report opens them directly.
//
// It wraps each element instead of sitting above them as a layout route,
// because a pathless parent makes react-router join the four absolute child
// paths onto "/ai-listening/", which it then rejects.
export const AiListeningRoute: FC<AiListeningRouteProps> = ({ children }) => {
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false)

  const { data: userFeatures, isLoading } = useGetUserFeaturesQuery()
  const hasAccess = userFeatures?.data?.aiListeningEnabled ?? false

  // Nothing at all while the flag is in flight. Rendering the page and then
  // replacing it with the disabled state — or the reverse — reads as a bug.
  if (isLoading) {
    return null
  }

  if (!hasAccess) {
    return (
      <>
        <EmptyState onEnableClick={() => setIsUpgradeModalOpen(true)} />
        <UpgradePlanModal
          isOpen={isUpgradeModalOpen}
          setIsOpen={setIsUpgradeModalOpen}
        />
      </>
    )
  }

  return <>{children}</>
}
